export default Object.freeze({
  PROPOSER: 'proposer',
  SECONDER: 'seconder'
})



// WEBPACK FOOTER //
// ./src/enums/prop-type.js